import axios from "axios";

import { API_BASE_URL } from "../utils/config";

const editGivenAccessoriesToDeliveryGuys = async (user, updatedValues, Id) => {
  try {
    if (!user) {
      return null;
    }

    const idTokenResult = await user.getIdTokenResult();
    if (idTokenResult.claims.admin === true || idTokenResult.claims.finance) {
      const idToken = await user.getIdToken();
      const res = await axios.put(
        `${API_BASE_URL}api/givenAccessoriesToDeliveryGuys/${Id}`,
        updatedValues,
        {
          headers: {
            Authorization: `Bearer ${idToken}`,
          },
        }
      );

      return res;
    } else {
      throw {
        response: {
          data: {
            message: "User is not authorized",
            type: "error",
          },
        },
      };
    }
  } catch (error) {
    throw error;
  }
};

export default editGivenAccessoriesToDeliveryGuys;
